/**
 * Support-related constants shared across frontend and backend
 */

export const SUPPORT_EMAIL = "support@jobolar.ai";

export const ERROR_MESSAGES = {
  EMAIL_BLACKLISTED: `Your email has been blocked for Flutterwave payments. Please contact ${SUPPORT_EMAIL} to resolve this.`,
} as const;
